import {Menu} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const MenuIcon = createLucideIcon(Menu, 'MenuIcon');
